import React, { useEffect, useMemo, useState } from 'react';

import Loader from '~/app/common/Loader';
import NetworkErrorMessage from '~/sqlite/NetworkErrorMessage';

import { DatabaseClient, setDatabaseClient } from './DatabaseClient';
import { DatabaseProvider } from './DatabaseContext';
import { initializeDatabase } from './databaseInit';

const SqliteProvider: React.FC = ({ children }) => {
  const [loading, setLoading] = useState<boolean>(!!window.sqlitePlugin);
  const [setupError, setSetupError] = useState(false);
  const [ready, setReady] = useState(!window.sqlitePlugin);

  const client = useMemo(
    () =>
      DatabaseClient.open(
        () => setLoading(false),
        () => setLoading(false)
      ),
    []
  );

  useEffect(() => {
    return () => {
      setDatabaseClient(null);
      client?.close();
    };
  }, [client]);

  useEffect(() => {
    if (!client || loading) {
      return;
    }

    let cancelled = false;

    (async () => {
      await initializeDatabase(client);
      if (cancelled) {
        return;
      }
      setDatabaseClient(client);
      setReady(true);
    })().catch((e) => {
      console.error('[SqliteProvider] database setup failed', e);
      if (!cancelled) {
        setSetupError(true);
      }
    });

    return () => {
      cancelled = true;
    };
  }, [client, loading]);

  if (!window.sqlitePlugin) {
    return <DatabaseProvider client={null}>{children}</DatabaseProvider>;
  }

  if (setupError) {
    return <NetworkErrorMessage />;
  }

  if (loading || !ready || !client) {
    return <Loader size="32" />;
  }

  return <DatabaseProvider client={client}>{children}</DatabaseProvider>;
};

export default SqliteProvider;
